import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: null,
    error: "",
  },
  action
) {
  switch (action.type) {
    case homeConstants.MESSAGE_MARK_AS_READ_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.MESSAGE_MARK_AS_READ_SUCCESS:
      return {
        data: action.response,
        isProgress: false,
      };
    case homeConstants.MESSAGE_MARK_AS_READ_FAILURE:
      return {
        data: null,
        isProgress: false,
      };
    default:
      return state;
  }
}
